import { isDropinTask } from "@/features/tasks/isDropinTask";
import { isFollowUpTask } from "@/features/tasks/isFollowUpTask";
import { type History, HistoryEntryTypeEnum } from "@repo/api";

export const isDropInHistory = (item: History) =>
  item.entryType === HistoryEntryTypeEnum.TASK_UPDATE &&
  (isDropinTask(item.details?.parent_task_type, item.details?.sub_task_type) ||
    isFollowUpTask(
      item.details?.parent_task_type,
      item.details?.sub_task_type
    ));
